import React from 'react';

import Migrate from './Migrate';
import Promote from './Promote';
import { VERSIONING_SECTION_IDS } from '../constants';

export type Props = {
  integrationId: ID;
  sectionContext: Record<string, any>;
  sectionId: ID;
  onClose?: () => void;
};

function Subsection({
  integrationId,
  sectionContext,
  sectionId,
  onClose,
}: Props) {
  const SubsectionComponent = {
    [VERSIONING_SECTION_IDS.PROMOTE]: Promote,
    [VERSIONING_SECTION_IDS.MIGRATE]: Migrate,
  }[sectionId];

  return (
    SubsectionComponent && (
      <SubsectionComponent
        integrationId={integrationId}
        onClose={sectionId === 'promote' ? onClose : undefined}
        sectionContext={sectionContext}
      />
    )
  );
}

export default Subsection;
